import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

new Swiper('.js-hero-carousel', {
  modules: [Navigation, Pagination, Autoplay],
  loop: true,
  slidesPerView: 1,
  spaceBetween: 26.5,
  autoplay: {
    delay: 3000,
  },
  breakpoints: {
    1024: {
      slidesPerView: 3,
    },
  },
});
